import { Document } from '@/shared/api/transcriptor';

import { TranscriptorConsultation } from '../config';

export const getConsultationDocuments = (
  consultation?: TranscriptorConsultation | null,
): Document[] => {
  if (!consultation) {
    return [];
  }

  const { documents, summary, evaluation, followUp, literatureReview } =
    consultation;

  if (documents?.length) {
    return documents;
  }

  return [summary, evaluation, followUp, literatureReview].filter(
    (document): document is Document => Boolean(document),
  );
};
